module.exports = __webpack_public_path__ + "media/images/autopilot/robot-outline-5ba844e9014abe84410d5415b2665c0a.svg";